(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('MaterialTemplates', MaterialTemplates);

    MaterialTemplates.$inject = ['$resource'];

    function MaterialTemplates ($resource) {
        var resourceUrl =  'api/material-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                    params: {
                        id: 'getPage'
                    },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    id: 'getAll'
                }
            } ,
            'delete':{
                method:'DELETE',
                params: {
                    login: 'id'
                }
            },
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET',
                params:{
                    id:'exists'
                }
            }
        });
    }
})();
